import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
export const FETCH_BILL_PROJECTION_WIDGET_DATA_SUCCESS = 'FETCH_BILL_PROJECTION_WIDGET_DATA_SUCCESS';
export const FETCH_BILL_PROJECTION_WIDGET_DATA_FAILED = 'FETCH_BILL_PROJECTION_WIDGET_DATA_FAILED';

export function fetchBillProjectionData(uuid, dateFormat) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/2.1/users/' + uuid + '/homes/1/billprojections', {
      params: {
        "date-format": dateFormat,
        round: true,
        "convert-to-kwh": true
      }
    }).then(
      (response) => {
        dispatch({
          type: FETCH_BILL_PROJECTION_WIDGET_DATA_SUCCESS,
          payload: response.data
        })
      },
      (error) =>{
        dispatch({
            type: FETCH_BILL_PROJECTION_WIDGET_DATA_FAILED,
            payload: error
        })
      }
    )
  }
}


